import React from "react"
import DealerFilter from "./DealerFilter"
import DistanceFilter from "./LocationFilter"
import PriceFilter from "./PriceFilter"
import AvailabilityFilter from "./AvailabilityFilter"

const StaticFilters: React.FC<{
  sortedFilters: any[]
  clearAllInventoryFilterQueue: any
  dispatchFilters: any
  clearFiltersModal: any
  filters: any[]
}> = ({ sortedFilters }) => {
  return (
    <>
      <DistanceFilter />
      <PriceFilter {...sortedFilters[0]} isExpanded={true} />
      <AvailabilityFilter sortedFilter={sortedFilters[1]} />
      <DealerFilter />
    </>
  )
}
export default StaticFilters
